import React from 'react';
// import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import ActiveFilters from './active-filters/ActiveFilters';
import FilterList from './filter-list/FilterList';

// FilterListWrapper component
const FilterListWrapper = ({ filters, filterSettings, activeFilters, toggleFilters, resetFilterGroup, focusedFilter, toggleFocus }) => {
    return (
        <div className="filters-section">
            <div className="filters-wrapper">
                <FilterList
                    filters={filters}
                    filterSettings={filterSettings}
                    activeFilters={activeFilters}
                    toggleFilters={toggleFilters}
                    focusedFilter={focusedFilter}
                    resetFilterGroup={resetFilterGroup}
                    toggleFocus={toggleFocus} />
            </div>
        </div>
    );
};

// ActiveFilterWrapper component
const ActiveFiltersWrapper = ({ activeFiltersLabel, activeFilters, showActiveFilters, resetFilters, toggleFilters }) => {
    if (!activeFilters.length || !showActiveFilters) { return null; }

    return (
        <div className='active-filters-section'>
            <div className="active-filters-wrapper">
                <ActiveFilters
                    activeFiltersLabel={activeFiltersLabel}
                    activeFilters={activeFilters}
                    resetFilters={resetFilters}
                    toggleFilters={toggleFilters} />
            </div>
        </div>
    );
};

const FilterContainer = ({ filters, activeFilters, filterSettings, toggleFilters, resetFilters, resetFilterGroup, focusedFilter, toggleFocus }) => {

    if (!filters || !filters.length) { return null; }

    return (
        <div className='filter-container-wrapper'>
            <FilterListWrapper
                filters = {filters}
                filterSettings = {filterSettings}
                activeFilters = {activeFilters}
                toggleFilters = {toggleFilters}
                resetFilters = {resetFilters}
                resetFilterGroup = {resetFilterGroup}
                focusedFilter = {focusedFilter}
                toggleFocus = {toggleFocus} />

            <ActiveFiltersWrapper
                activeFiltersLabel = {filterSettings.activeFiltersLabel}
                activeFilters = {activeFilters}
                showActiveFilters = {filterSettings.showActiveFilters}
                resetFilters = {resetFilters}
                toggleFilters = {toggleFilters} />
        </div>
    );
};

FilterContainer.propTypes = {
    filters: React.PropTypes.arrayOf(React.PropTypes.object).isRequired,
    activeFilters: React.PropTypes.arrayOf(React.PropTypes.object).isRequired,
    filterSettings: React.PropTypes.object.isRequired,
    toggleFilters: React.PropTypes.func,
    resetFilters: React.PropTypes.func,
    resetFilterGroup: React.PropTypes.func,
    focusedFilter: React.PropTypes.object,
    toggleFocus: React.PropTypes.func.isRequired
};

export default FilterContainer;



/** WEBPACK FOOTER **
 ** ./src/components/filtered-listing/filters/FilterContainer.jsx
 **/